<!-- mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="девайсы">
        <app-device-list-page></app-device-list-page>
    </mat-tab>
    <mat-tab label="агенты">
        <app-agent-devices></app-agent-devices>
    </mat-tab>
    <mat-tab label="токен">
        <app-token-generator></app-token-generator>
    </mat-tab>


</mat-tab-group -->

<h1>agent</h1>
<pre>{{cm.activeServer | json}}</pre>
<h1>user</h1>
<pre>{{cm.activeUser | json}}</pre>